export let TextWrap;
(function (TextWrap) {
  TextWrap["NONE"] = "none";
  TextWrap["ON"] = "on";
})(TextWrap || (TextWrap = {}));
export let HorizontalAlignment;
(function (HorizontalAlignment) {
  HorizontalAlignment["CENTER"] = "center";
  HorizontalAlignment["DEFAULT"] = "default";
  HorizontalAlignment["LEFT"] = "left";
  HorizontalAlignment["RIGHT"] = "right";
})(HorizontalAlignment || (HorizontalAlignment = {}));
export let VerticalAlignment;
(function (VerticalAlignment) {
  VerticalAlignment["BOTTOM"] = "bottom";
  VerticalAlignment["DEFAULT"] = "default";
  VerticalAlignment["MIDDLE"] = "middle";
  VerticalAlignment["TOP"] = "top";
})(VerticalAlignment || (VerticalAlignment = {}));
export let UnderlineStyle;
(function (UnderlineStyle) {
  UnderlineStyle["NONE"] = "none";
  UnderlineStyle["STRIKETHROUGH"] = "strikethrough";
  UnderlineStyle["UNDERLINE"] = "underline";
})(UnderlineStyle || (UnderlineStyle = {}));
export let ItalicStyle;
(function (ItalicStyle) {
  ItalicStyle["ITALIC"] = "italic";
  ItalicStyle["NONE"] = "none";
})(ItalicStyle || (ItalicStyle = {}));
//# sourceMappingURL=Text.js.map